<ul class="source-strip">
  @for (row of rows(); track row.key) {
    <li class="source-strip__row">
      <mat-icon
        class="source-strip__icon"
        [attr.title]="'installations.insights.strip.provenance.' + row.provenance | translate"
        >{{ provenanceIcon(row.provenance) }}</mat-icon
      >
      @if (row.deviceLink) {
        <a class="source-strip__identity source-strip__link" [routerLink]="row.deviceLink">{{
          row.identity
        }}</a>
      } @else {
        <span class="source-strip__identity">{{ row.identity }}</span>
      }
      @if (row.lastDataAt !== undefined) {
        <span class="source-strip__freshness" [attr.title]="instant(row.lastDataAt)">
          {{ 'installations.insights.strip.lastData' | translate }} {{ relative(row.lastDataAt) }}
        </span>
      }
      @if (row.warning) {
        @if (stateLink(); as link) {
          <a class="source-strip__state-link" [routerLink]="link">
            <xemex-tag
              state="warning"
              icon="warning"
              [label]="'installations.bindingState.' + row.warning | translate"
            ></xemex-tag>
          </a>
        } @else {
          <xemex-tag
            state="warning"
            icon="warning"
            [label]="'installations.bindingState.' + row.warning | translate"
          ></xemex-tag>
        }
      }
      @if (row.sources.length > 1) {
        <button type="button" class="source-strip__toggle" (click)="toggle(row)">
          {{
            'installations.insights.strip.sourceCount' | translate: { count: row.sources.length }
          }}
          <mat-icon>{{ expanded().has(row.key) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      }
    </li>
    @if (expanded().has(row.key)) {
      @for (source of row.sources; track source.from) {
        <li class="source-strip__row source-strip__row--nested">
          <mat-icon
            class="source-strip__icon"
            [attr.title]="
              'installations.insights.strip.provenance.' + source.provenance | translate
            "
            >{{ provenanceIcon(source.provenance) }}</mat-icon
          >
          @if (sourceLink(source.source); as link) {
            <a class="source-strip__identity source-strip__link" [routerLink]="link">{{
              sourceIdentity(source.source)
            }}</a>
          } @else {
            <span class="source-strip__identity">{{ sourceIdentity(source.source) }}</span>
          }
          <span class="source-strip__freshness">
            {{ instant(source.from) }} –
            {{ source.to ? instant(source.to) : ('installations.insights.strip.now' | translate) }}
          </span>
        </li>
      }
    }
  }
</ul>
